import { useCallback, useEffect } from "react"
import { useDrag } from "react-use-gesture"
import { AREA_RATIO, ARROW_LEFT, ARROW_RIGHT } from "../shared/util"

/**
 * スワイプ動作のためのハンドラーを返すhooks
 */
export const useVolumeViewerNavigation = (
  viewerElement: HTMLDivElement | null,
  toNext: () => void,
  toPrev: () => void,
  toShowMenu: () => void,
) => {
  const handleDrag = (xDir: number, cancel: () => void) => {
    // ページ遷移
    // 次へ
    // 2
    if (xDir > 0) {
      toNext()
    }

    // 前へ
    if (xDir < 0) {
      toPrev()
    }

    cancel()
  }

  const handleTap = (initialX: number) => {
    if (!viewerElement) {
      toShowMenu()

      return
    }

    const viewerRect = viewerElement.getBoundingClientRect()
    const pointX = initialX - viewerRect.x

    const isNext = pointX / viewerRect.width < AREA_RATIO
    if (isNext) {
      toNext()

      return
    }

    const isPrev = pointX / viewerRect.width > 1 - AREA_RATIO
    if (isPrev) {
      toPrev()

      return
    }

    toShowMenu()
  }

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      const { keyCode } = event
      if (keyCode !== ARROW_LEFT && keyCode !== ARROW_RIGHT) {
        return
      }

      if (keyCode === ARROW_LEFT) {
        toNext()

        return
      }

      if (keyCode === ARROW_RIGHT) {
        toPrev()

        return
      }
    },
    [toNext, toPrev],
  )

  const bind = useDrag(
    ({
      down,
      direction: [xDir],
      distance,
      cancel,
      tap: isTap,
      initial,
      swipe: [swipeX],
    }) => {
      // distance > 0 だとタップで反応しかねないので、いったん 5 で指定
      const isDrag = down && distance > 5
      const isSwipe = swipeX !== 0

      if (isTap) {
        handleTap(initial[0])

        return
      }

      if (isSwipe) {
        return
      }

      if (isDrag && cancel) {
        handleDrag(xDir, cancel)

        return
      }
    },
  )

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown)

    return () => {
      window.removeEventListener("keydown", handleKeyDown)
    }
  }, [handleKeyDown])

  return { bind }
}
